import { render, staticRenderFns } from "./menberPage.vue?vue&type=template&id=6d53fd48&scoped=true"
import script from "./menberPage.vue?vue&type=script&lang=js"
export * from "./menberPage.vue?vue&type=script&lang=js"
import style0 from "./menberPage.vue?vue&type=style&index=0&id=6d53fd48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53fd48",
  null
  
)

export default component.exports